module.exports = "plr-history-back-button,\nplr-ribbon,\nplr-side-navigation {\n  display: none !important; }\n\nplr-side-navigation-layout .root-container,\nplr-side-navigation-layout plr-page-layout {\n  background: white; }\n\nplr-side-navigation-layout .root-container > .content-wrapper,\n  plr-side-navigation-layout plr-page-layout > .content-wrapper {\n    margin-right: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/portal/portal.component.scss
// module id = ./src/app/portal/portal.component.scss
// module chunks = main